import MobileWarningDialog from './MobileWarningDialog';

export { MobileWarningDialog };
export default MobileWarningDialog;
